import { NavLink } from "react-router-dom";
import { UsersRound, Store, IdCard, GitPullRequestCreateArrow, Gift, FileChartColumnIncreasing } from "lucide-react";
// import { useAuth } from "../context/AuthContext";

export default function Index() {
  // const { user } = useAuth();
  // console.log(user);
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mt-4">
      {[
        { icon: <UsersRound size={24} />, label: "Customers", pageurl: "customer" },
        { icon: <Store size={24} />, label: "Stores", pageurl: "store" },
        { icon: <IdCard size={24} />, label: "Loyalty Card", pageurl: "/loyalty/loyalty_card" },
        {
          icon: <GitPullRequestCreateArrow size={24} />,
          label: "Assign Loyalty Card",
          pageurl: "loyalty/customer_card",
        },
        { icon: <Gift size={24} />, label: "Rewards Rules", pageurl: "/loyalty/reward" },
        { icon: <FileChartColumnIncreasing size={24} />, label: "Report", pageurl: "report" },
      ].map((item, index) => (
        <NavLink to={item.pageurl} key={index}>
          <div className="p-4 bg-white rounded-xl shadow flex flex-col items-center hover:shadow-md transition">
            <div className="text-blue-500">{item.icon}</div>
            <p className="mt-2 text-sm font-medium text-gray-700 text-center">{item.label}</p>
          </div>
        </NavLink>
      ))}
    </div>
  );
}
